import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface TypeFilterProps {
  types: Array<{ label: string; icon: string }>;
  selectedType: string;
  onTypeChange: (type: string) => void;
}

const TypeFilter: React.FC<TypeFilterProps> = ({ types, selectedType, onTypeChange }) => {
  return (
    <div className="flex flex-wrap gap-3">
      {types.map((type) => (
        <button
          key={type.label}
          onClick={() => onTypeChange(type.label)}
          className={`flex items-center space-x-2 px-4 py-2 rounded-lg font-body text-sm font-medium transition-all duration-300 ${
            selectedType === type.label
              ? 'bg-secondary text-secondary-foreground shadow-md scale-105'
              : 'bg-card border border-border text-foreground hover:border-secondary hover:text-secondary'
          }`}
        >
          <Icon name={type.icon as any} size={18} />
          <span>{type.label}</span>
        </button>
      ))}
    </div>
  );
};

export default TypeFilter;